import { Injectable } from "@angular/core";
import { ContoDTO } from "../dto/contoDTO";
import { ContoVO } from "../vo/contoVO";
import { MapperInterface } from "./mapper-inteface";

@Injectable({ providedIn: "root" })
export class MapperConto implements MapperInterface<ContoDTO, ContoVO> {
  constructor() {}

  convertVoToDto(contoVO: ContoVO): ContoDTO {
    if (contoVO != null) {
      // console.log("[MapperSettore] contoVO => contoDTO", contoVO);
      const contoDTO = new ContoDTO();

      contoDTO.conto = contoVO.conto;
      contoDTO.capienza = contoVO.capienza;
      contoDTO.residuo = contoVO.residuo;
      contoDTO.area = contoVO.area;
      contoDTO.descrizione = contoVO.descrizione;


      // console.log("return", contoDTO);
      return contoDTO || new ContoDTO();
    } else {
      return null;
    }
  }

  convertDtoToVo(contoDTO: ContoDTO): ContoVO {
    if (contoDTO != null) {
      // console.log("[MapperSettore] contoVO => contoDTO", contoVO);
      const contoVO = new ContoVO();

      contoVO.conto = contoDTO.conto;
      contoVO.capienza = contoDTO.capienza;
      contoVO.residuo = contoDTO.residuo;
      contoVO.area = contoDTO.area;
      contoVO.descrizione = contoDTO.descrizione;
      // console.log("return", contoDTO);
      return contoVO || new ContoVO();
    } else {
      return null;
    }
  }

  convertListVoToDto(contoVOList: ContoVO[]): ContoDTO[] {
    // console.log("[MapperDocumenti] documentoDTOList => documentoVOList");

    const contoDTOList = new Array<ContoDTO>();
    contoVOList.forEach((vo) => {
      contoDTOList.push(this.convertVoToDto(vo));
    });

    return contoDTOList || new Array<ContoDTO>();
  }

  convertListDtoToVo(contoDTOList: ContoDTO[]): ContoVO[] {
    // console.log("[MapperSettori] contoDTOList => contoDTOList");
    // console.log("contoDTOList", contoDTOList);
    const contoVOList = new Array<ContoVO>();
    contoDTOList.forEach((dto) => {
      contoVOList.push(this.convertDtoToVo(dto));
    });

    return contoVOList || new Array<ContoVO>();
  }
}
